const defaultConfiguration = {
    "imageUrl": "https://d2hktiwoh6jv8u.cloudfront.net/files/Image/original/07da8e5s-d839-4894-b3dc-2e2eaf59d818.jpg",
    "domain": "gustavo.byhours.com",
    "primaryColor": "#ff5e1e",
    "secondaryColor": "#bd10e0",
    "fontFamily": "Gordita",
};

export default defaultConfiguration;